/**
 * @generated SignedSource<<43fe06258b921733adf6d53d9e3fe00c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type queueFragment_CancelMutation$variables = {
  jobId: number;
};
export type queueFragment_CancelMutation$data = {
  readonly accountJobCancel: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly outcome: string;
  } | null | undefined;
};
export type queueFragment_CancelMutation = {
  response: queueFragment_CancelMutation$data;
  variables: queueFragment_CancelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jobId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "jobId",
    "variableName": "jobId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outcome",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "queueFragment_CancelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountJobCancelMutationPayload",
        "kind": "LinkedField",
        "name": "accountJobCancel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queueFragment_CancelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountJobCancelMutationPayload",
        "kind": "LinkedField",
        "name": "accountJobCancel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "080f68409ece5a822bdebe39930190bb",
    "id": null,
    "metadata": {},
    "name": "queueFragment_CancelMutation",
    "operationKind": "mutation",
    "text": "mutation queueFragment_CancelMutation(\n  $jobId: Int!\n) {\n  accountJobCancel(jobId: $jobId) {\n    outcome\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9de0251b7aba40e7fd759aed338d0e03";

export default node;
